import { FaSearch } from "react-icons/fa";
import "./SearchBar.css";

function SearchBar({ value, onChange, placeholder = "Search..." }) {
  return (
    <div className="search-bar-container">
      <FaSearch className="search-icon" />
      <input
        type="text"
        className="search-input"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
      />
    </div>
  );
}

export default SearchBar;